import styled from 'styled-components';
import SearchResultsTail from '../../../search-results/common/wires-list-tail';

const Tail = styled(SearchResultsTail)`
  justify-content: left;
  align-items: left;

  > button {
    color: #19202D;
    background: #F3F4F6;
    height: 48px;
    width: 225px;
    &:hover {
      background-color: #D7DFE7;
    }
  }
`;

export default Tail;
